// src/pages/Training.jsx
// Wrapper area operatore (route /allenamento): mostra il setup oppure la vista
// live se una sessione è già attiva. Il token della sessione (ottenuto
// all'avvio o dal link della sessione) è conservato in sessionStorage per
// sopravvivere ai refresh di pagina. Gli allenamenti non hanno password.
import React, { useState, useEffect, useCallback } from 'react';
import TrainingSetup from './TrainingSetup';
import TrainingLive from './TrainingLive';
import './TrainingLive.css';

const API_BASE = process.env.REACT_APP_API_BASE || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);
const tokenKey = (id) => `rs_training_token_${id}`;

export default function Training() {
  const [session, setSession] = useState(null); // { trainingId, token }
  const [loading, setLoading] = useState(true);
  const [savedId, setSavedId] = useState(null);  // sessione appena terminata (link al riepilogo)

  const bootstrap = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/api/training/state`);
      const j = await r.json();
      if (j?.active && j.trainingId) {
        let token = null;
        try { token = sessionStorage.getItem(tokenKey(j.trainingId)); } catch { }
        if (!token) {
          // sessione già in corso (avviata da un'altra scheda o prima di un
          // refresh): il token si riprende dal link della sessione
          const ra = await fetch(`${API_BASE}/api/training/${encodeURIComponent(j.trainingId)}/access`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}',
          });
          const ja = await ra.json().catch(() => ({}));
          if (ra.ok && ja.mode === 'live' && ja.token) {
            token = ja.token;
            try { sessionStorage.setItem(tokenKey(j.trainingId), token); } catch { }
          }
        }
        setSession(token ? { trainingId: j.trainingId, token } : null);
      } else {
        setSession(null);
      }
    } catch {
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  // Dal setup alla sessione (e ritorno) l'indirizzo resta /allenamento, quindi
  // lo scorrimento della pagina non si azzera da solo: si riparte dall'alto.
  useEffect(() => { window.scrollTo(0, 0); }, [session?.trainingId]);

  const handleStart = ({ trainingId, token }) => {
    try { sessionStorage.setItem(tokenKey(trainingId), token); } catch { }
    setSavedId(null);
    setSession({ trainingId, token });
  };

  const handleStop = (stoppedId) => {
    if (session?.trainingId) { try { sessionStorage.removeItem(tokenKey(session.trainingId)); } catch { } }
    setSavedId(stoppedId || session?.trainingId || null);
    setSession(null);
    bootstrap();
  };

  if (loading) {
    return (
      <div className="rs-page">
        <div className="tl-loading"><span className="rs-spinner" />Caricamento sessione…</div>
      </div>
    );
  }

  if (session) {
    return <TrainingLive token={session.token} trainingId={session.trainingId} onStop={handleStop} />;
  }

  return <TrainingSetup onStart={handleStart} savedId={savedId} onDismissSaved={() => setSavedId(null)} />;
}
